import React, { useState } from "react";
import "./Modal.css";
import config from "../../config";

//component
import InputLogin from "./inputLogin";
import { CircularProgress } from "@material-ui/core";

// styles
import useStyles from "../login/styles";

const Modal = ({ children, isOpen, closeModal, autoClose }) => {
    var classes = useStyles();
    const handleContainerClick = (e) => e.stopPropagation();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    var [isLoading, setIsLoading] = useState(false);
    var [loginValue, setLoginValue] = useState({ text: '' });
    var [passwordValue, setPasswordValue] = useState({ text: '' });

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (loginValue.text != "" && passwordValue.text != "") {
            const newLogin = {
                email: loginValue.text, password: passwordValue.text
            };

            const response = await fetch(baseUrl + "login", {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(newLogin)
            });

            const json = await response.json();
            if (json.status.message == "Ok") {
                localStorage.setItem('token', json.content.token);
                localStorage.setItem('name', json.content.name + json.content.lastName);
                localStorage.setItem('idUserSystem', json.content.id);
                if (json.content.userType == "Administrador") {
                    localStorage.setItem('id_token', 1)
                } else {
                    if (json.content.userType == "Coach") {
                        localStorage.setItem('id_token', 2)
                    } else {
                        localStorage.setItem('id_token', 3)
                    }
                }
            }

            setLoginValue({ text: '' });
            setPasswordValue({ text: '' });
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }

        closeModal();
    }

    return <article className={`modal ${isOpen && "is-open"}`}
        onClick={closeModal}>
        <div className="modal-container" onClick={handleContainerClick}>
            <button
                style={{
                    position: "absolute",
                    top: "1rem",
                    right: "1rem",
                    backgroundColor: "#FFFFFF",
                    color: "#000000",
                    fontSize: "14px",
                    padding: "6px 10px",
                    borderRadius: '3px',
                    margin: "auto",
                    cursor: 'pointer',
                    borderWidth: "0px",
                }}
                onClick={closeModal}
            >X</button>
            <InputLogin
                text={loginValue}
                setValue={setLoginValue}
                type="email"
                label="Correo"
                name="email"
                placeholder="correo@correo.com"
                isRequired={true}
            />

            <InputLogin
                text={passwordValue}
                setValue={setPasswordValue}
                type="password"
                label="Contraseña"
                name="password"
                placeholder="Contraseña"
                isRequired={true}
            />
            <div className={classes.formButtons}>
                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginLoader} />
                ) : (
                    <button
                        className={loginValue.text.length === 0 || passwordValue.text.length === 0 ?
                            classes.disableButton : classes.enableButton}
                        disabled={(loginValue.text.length === 0 || passwordValue.text.length === 0)}
                        onClick={onSubmit}
                    >Inicio</button>
                )}
            </div>
        </div>
    </article>
}

export default Modal;